import { Filter, FilterType, FilterKey } from 'api-paths-cas';
import { orderBy } from 'lodash';
import { IGetFilterGroupsProps } from '../../types';

const key = FilterKey.APPLICATION_COUNTRY;
export const getApplicationCountryFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const applicationCountryFilterOptions = filterOptions?.applicationCountry || [];

  const options = applicationCountryFilterOptions.map(country => {
    return {
      label: country,
      value: country,
      checked: filters.some(filter => filter === country),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Application country',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
